export default __webpack_public_path__ + "static/media/image-cover.0371e4cd.png";